var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRpgGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175 512h-4A226 226 0 0 1 0 292V137c0-6 3-11 8-13 55-28 112-42 167-42s112 14 167 42c5 2 8 7 8 13v155a226 226 0 0 1-175 220zm0 0",
    fill: "#ffce59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342 124c-55-28-112-42-167-42v430h4a226 226 0 0 0 171-220V137c0-6-3-11-8-13zm0 0",
    fill: "#ffb229"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175 482A196 196 0 0 1 30 292V146c48-22 97-34 145-34s97 12 145 34v146c0 89-59 166-145 190zm0 0",
    fill: "#61bcff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320 292V146c-48-22-97-34-145-34v370c86-24 145-101 145-190zm0 0",
    fill: "#009dff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M248 392H135c-9 0-15-6-15-15V264c0-4 2-9 5-12L330 90c6-5 15-4 20 1l71 71c5 5 6 14 1 20L260 387c-3 3-8 5-12 5zm0 0",
    fill: "#e2f1ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135 392h113c4 0 9-2 12-5l162-205c5-6 4-15-1-20l-35-36-262 262c3 3 7 4 11 4zm0 0",
    fill: "#c5e3ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262 265a15 15 0 0 1-11-26l113-113a15 15 0 1 1 22 22L273 261c-3 3-7 4-11 4zm0 0",
    fill: "#c5e3ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262 265c4 0 8-1 11-4l113-113c6-6 6-16 0-22L251 261c3 3 7 4 11 4zm0 0",
    fill: "#a5d4ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M396 173c-4 0-8-1-10-4l-43-43c-6-6-6-15 0-21l43-42a15 15 0 0 1 21 0l42 42a15 15 0 0 1 0 21l-42 43c-3 3-7 4-11 4zm0 0",
    fill: "#ffce59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M386 169a15 15 0 0 0 21 0l42-43a15 15 0 0 0 0-21l-21-21-64 64zm0 0",
    fill: "#ffb229"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M425 201c-4 0-8-1-11-4l-99-99a15 15 0 1 1 21-21l99 99a15 15 0 0 1-10 25zm0 0",
    fill: "#525967"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M414 197a15 15 0 0 0 21 0c6-6 6-15 0-21l-49-50-22 22zm0 0",
    fill: "#3b4851"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M386 63l49-50a45 45 0 0 1 64 64l-50 49zm0 0",
    fill: "#61bcff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M499 13l-81 81 31 32 50-49a45 45 0 0 0 0-64zm0 0",
    fill: "#009dff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpgGame);
export default __webpack_public_path__ + "static/media/rpg-game.b6d3fa7f6c0bfc9bd21352bd1c90fe68.svg";
export { ForwardRef as ReactComponent };